import { render, staticRenderFns } from "./JobDeliveryList.vue?vue&type=template&id=37bc57aa&scoped=true&"
import script from "./JobDeliveryList.vue?vue&type=script&lang=ts&"
export * from "./JobDeliveryList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bc57aa",
  null
  
)

export default component.exports